(function (){
    'use strict';

    angular
        .module('app')
        .directive('course', course);

    course.$inject = ['ProfileTypeService', 'LanguageCourseService', 'InterestCourseService'];
    function course(ProfileTypeService, LanguageCourseService, InterestCourseService) {
        var directive =  {
            restrict:'E',
            scope:{
                arrayItems:'=items'
            },
            templateUrl: 'templates/directives/course/view/course.html',
            link:link,
            controller:courseCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;

        function link(scope, element, attrs, ctrl) {
            var vm = this;
            vm.profileTypeList           = [];
            vm.profileTypeSelected       = [];
            vm.interestCourseSelected    = [];
            vm.interestCourseList        = [];
            vm.interestLanguageSelected  = [];
            vm.interestLanguageList      = [];
        }
    }

    courseCtrl.$inject = ['ProfileTypeService', 'LanguageCourseService', 'InterestCourseService', '$scope', '$compile','$timeout'];
    function courseCtrl(ProfileTypeService, LanguageCourseService, InterestCourseService, $scope, $compile, $timeout) {
        var vm = this;
        vm.item                     = [];
        vm.profileTypeSelected      = [];
        vm.profileTypeList          = [];
        vm.interestCourseSelected   = [];
        vm.interestCourseList       = [];
        vm.interestLanguageSelected = [];
        vm.interestLanguageList     = [];
        vm.profileClass1            = false;
        vm.profileClass2            = true;
        vm.selectProfiles           = selectProfiles;
        vm.selectInterestCourse     = selectInterestCourse;
        vm.selectLanguagesCourse    = selectLanguagesCourse;
        vm.loadSelect               = loadSelect;
        vm.fillArray                = fillArray;
        vm.remove                   = remove;
        vm.onRemove                 = onRemove;

        function activate() {
            selectProfiles();
        }

        function selectProfiles () {
            ProfileTypeService.getProfilesType().then(function(response){
                vm.profileTypeList = response.data;
                vm.profileTypeList.unshift({id: "-1", alias: " ", name: "", full_name: " "});
                $timeout(function(){
                    if(Object.keys(vm.arrayItems).length !== 0) {                        
                        vm.profileTypeSelected = vm.arrayItems.profile_type;
                        if (Array.isArray(vm.arrayItems.profile_type) && typeof vm.arrayItems.profile_type[0] !== 'undefined') {
                            vm.profileTypeSelected = vm.arrayItems.profile_type[0];
                            if (vm.arrayItems.profile_type[0].length > 1) {
                                vm.arrayItems.profile_type[0].map( element => {
                                    vm.selectInterestCourse(element.id);
                                    if(element.id === 1) {
                                        vm.selectLanguagesCourse();
                                    }
                                });
                            }
                            if (vm.arrayItems.profile_type[0].length === 1) {
                                if(vm.arrayItems.profile_type[0][0].id === 1) {
                                    vm.selectLanguagesCourse();
                                } else {
                                    vm.selectInterestCourse(vm.arrayItems.profile_type[0][0].id);
                                }
                            }
                        }
                        vm.interestCourseSelected = vm.arrayItems.interest_course;
                        if (Array.isArray(vm.arrayItems.interest_course) && typeof vm.arrayItems.interest_course[0] !== 'undefined') {
                            vm.interestCourseSelected = vm.arrayItems.interest_course[0];
                        }
                        // vm.selectLanguagesCourse();
                        vm.interestLanguageSelected = vm.arrayItems.interest_language;
                        if (Array.isArray(vm.arrayItems.interest_language) && typeof vm.arrayItems.interest_language[0] !== 'undefined') {
                            vm.interestLanguageSelected = vm.arrayItems.interest_language[0];
                        }
                    }
                },2);
            }).catch(function(err) {
            });
        }

        function loadSelect() {
            var item = {};
            if(typeof vm.arrayItems === 'undefined')
                vm.arrayItems = [];
            if(typeof vm.arrayItems['profile_type'] === 'undefined' || vm.arrayItems['profile_type'].length === 0 || vm.arrayItems['profile_type'] === []) {
                vm.arrayItems['profile_type'] = [];
            }
            item.profile_type = vm.profileTypeSelected;
            if(typeof vm.arrayItems['profile_type'] !== 'undefined') {
                vm.arrayItems['profile_type'] = [];
            }

            vm.arrayItems['profile_type'].push(item.profile_type);
            vm.profileTypeSelected.find( element => {
                if(element.id === 1) {
                    vm.profileClass1 = true;
                    vm.selectLanguagesCourse();
                    vm.selectInterestCourse(element.id);
                }
                if(element.id !== 3 || element.id !== 6) {
                    vm.profileClass2 = true;
                    vm.selectInterestCourse();
                }
            })
            if (vm.profileTypeSelected.length === 0) {
                vm.interestLanguageSelected = '';
                vm.interestCourseSelected = '';
                vm.profileClass1 = false;
                vm.profileClass2 = false;
            }
        }

        function selectLanguagesCourse () {
            LanguageCourseService.getAll().then(function(response){
                vm.interestCourseList = response.data;
                vm.profileClass1 = true;
            }).catch(function(err) {
            });
        }

        function fillArray(param) {
            var item = [];
            if(typeof vm.arrayItems['profile_type'] === 'undefined' || vm.arrayItems['profile_type'].length === 0 || vm.arrayItems['profile_type'] === '')
                vm.arrayItems['profile_type'] = [];
            if(vm.arrayItems['profile_type'].length > 0)
                vm.arrayItems['profile_type'].shift();
            item['profile_type'] = vm.profileTypeSelected;
            vm.arrayItems['profile_type'].push(item['profile_type']);

            if(param === 'interest') {
                if (typeof vm.arrayItems['interest_language'] === 'undefined' || vm.arrayItems['interest_language'].length === 0){
                    vm.arrayItems['interest_language'] = [];
                }
                if(vm.arrayItems['interest_language'].length > 0)
                    vm.arrayItems['interest_language'].shift();
                item['interest_language'] = vm.interestLanguageSelected;
                vm.arrayItems['interest_language'].push(item['interest_language']);
            } else {
                if(typeof vm.arrayItems['interest_course'] === 'undefined' || vm.arrayItems['interest_course'].length === 0) {
                    vm.arrayItems['interest_course'] = [];
                }
                if(vm.arrayItems['interest_course'].length > 0)
                    vm.arrayItems['interest_course'].shift();
                item['interest_course'] = vm.interestCourseSelected;
                vm.arrayItems['interest_course'].push(item['interest_course']);
            }
        }

        function selectInterestCourse (is_language_course) {
            is_language_course = (is_language_course == true || is_language_course == 13);
            var query = [];
            query['is_language_course'] = false;
            if(is_language_course) {
                query['is_language_course'] = true;
                InterestCourseService.getAll(query).then(function(response){
                    vm.interestLanguageList = response.data;
                    vm.profileClass1 = true;
                }).catch(function(err) {
                });
            } else {
                InterestCourseService.getAll(query).then(function(response){
                    vm.interestCourseList = response.data;
                }).catch(function(err) {
                });
            }
        }

        function onRemove(type) {
            if(type === 'profile_type') {
                vm.arrayItems['profile_type']= [];
                vm.arrayItems['profile_type'].push(vm.profileTypeSelected);
                if (vm.profileTypeSelected.length === 0) {
                    vm.arrayItems['profile_type'] = [];
                    vm.arrayItems['interest_language'] = [];
                    vm.arrayItems['interest_course'] = [];
                }
            }
            if(type === 'interest_language'){
                vm.arrayItems['interest_language'] = [];
                if (vm.interestLanguageSelected.length > 0) {
                    vm.arrayItems['interest_language'].push(vm.interestLanguageSelected);
                }
            }
            if(type === 'interest_course'){
                vm.arrayItems['interest_course'] = [];
                if (vm.interestCourseSelected.length > 0) {
                    vm.arrayItems['interest_course'].push(vm.interestCourseSelected);
                }
            }
            vm.profileClass1 = !!vm.profileTypeSelected.find(element => element.id === 1);
            vm.profileClass2 = !!vm.profileTypeSelected.find(element => element.id !== 3 || element.id !== 6);
            if(!vm.profileClass1) {
                vm.interestLanguageSelected = [];
                vm.arrayItems['interest_language'] = [];
            }
            if (vm.profileTypeSelected.length === 0) {
                vm.interestLanguageSelected = [];
                vm.interestCourseSelected = [];
                vm.arrayItems['profile_type'].delete();
                vm.arrayItems['interest_language'].delete();
                vm.arrayItems['interest_course'].delete();
                vm.profileClass1 = false;
                vm.profileClass2 = false;
            }
        }

        function remove(data) {
            vm.arrayItems.splice(vm.arrayItems.indexOf(data), 1);
        }
        activate();
    }
})();
